import { useGroupComponentProps } from '../common/lobby/useGroupComponentProps';
import { useGroupsPreview } from '../common/lobby/useGroupsPreview';
import { GlobalDesignActionLobbyItem } from '../types';
import { StrictGroupValueEntries } from '../common/lobby/types';
import React from 'react';

const getBorderWidthPlaceholder = (value: string) => ({ value, unit: '' });

const DEFAULT_VALUES = {
  borderColor: {
    value: '',
    type: 'HexColor',
  },
  borderWidth: null,
  borderStyle: null,
  isMixedBorderColor: false,
  isMixedBorderStyle: false,
  isMixedBorderWidth: false,
};

const BorderLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const GroupPreviewComponent = useGroupsPreview('border', props.group);
  const groupComponentProps = useGroupComponentProps<
    typeof DEFAULT_VALUES,
    'Border'
  >(props.group, DEFAULT_VALUES, (acc, styleValue) => {
    const styleValueEntries = Object.entries(
      styleValue,
    ) as StrictGroupValueEntries<'Border'>;

    // @ts-expect-error - TODO: ds-types-bump
    styleValueEntries.forEach(([key, style]) => {
      if (!style) {
        return;
      }

      if (key === 'width') {
        if (!acc.borderWidth) {
          acc.borderWidth = style;
        } else if (acc.borderWidth.value !== style.value) {
          acc.isMixedBorderWidth = true;
        }
      }

      if (key === 'style') {
        if (!acc.borderStyle) {
          acc.borderStyle = style.value;
        } else if (acc.borderStyle !== style.value) {
          acc.isMixedBorderStyle = true;
        }
      }

      if (key === 'color') {
        if (!acc.borderColor.value && style.type === 'HexColor') {
          acc.borderColor = style;
        } else if (
          style.type === 'HexColor' &&
          acc.borderColor.value !== style.value
        ) {
          acc.isMixedBorderColor = true;
        }
      }
    });

    return acc;
  });

  const borderWidth =
    groupComponentProps.borderWidth ||
    getBorderWidthPlaceholder(props.group.displayName);

  if (!GroupPreviewComponent) {
    return null;
  }

  return (
    <GroupPreviewComponent
      value={{
        ...groupComponentProps,
        borderWidth,
      }}
      onClick={props.onSelect}
    />
  );
};

export default BorderLobbyItem;
